import types from '/src/store/types'
// import Cookies from 'js-cookie'
// import moment from 'moment'
import { api } from '@/api'

export default {
  loadPromotions: ({ rootState, getters, commit }) => new Promise((resolve, reject) => {
    api.loadPromotions().then(response => {
      commit(types.content.SET_PROMOTIONS, response.body)
      resolve()
    }).catch(error => {
      reject(error)
    })
  }),
  loadRestaurants: ({ rootState, getters, commit }) => new Promise((resolve, reject) => {
    api.loadRestaurants().then(response => {
      commit(types.content.SET_RESTAURANTS, response.body)
      resolve()
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/content/actions.js